module.exports = __webpack_public_path__ + "img/5.a241e2f1.jpg";